// tslint:disable comment-format

//=======================================================================
// Interfaces
//=======================================================================
export interface IRating {
    source: string;
    date: string;
    rating: string;
    acclaim?: string;
}

export interface IRatingHash {
    [productID: string]: IRating[];
}

//=======================================================================
// List of Ratings, by product ID
//=======================================================================
export const ratings: IRatingHash = {

    //=======================================================================
    // 14 HANDS
    //=======================================================================

    // 14 Hands | 2013 The Reserve Red Wine Blend, Horse Heaven Hills
    5637151552: [
        {
            source: 'Wine & Spirits',
            date: '8.1.16',
            rating: '91 Points'
        }
    ],

    // 14 Hands | 2015 The Reserve Cabernet Sauvignon, Horse Heaven Hills
    5637151737: [
        {
            source: 'The Wine Advocate',
            date: '10.1.18',
            rating: '91 Points'
        },
        {
            source: 'Wine & Spirits',
            date: '10.1.18',
            rating: '91 Points'
        }
    ],

    // 14 Hands | 2016 Riesling, Washington State
    5637151746: [
        // 88 Points: Best Value | Wine Spectator | May 31, 2018
        {
            source: 'Wine Spectator',
            date: '5.31.18',
            rating: '88 Points',
            acclaim: 'Best Value'
        }
    ],

    // 14 Hands | Brut Rosé, Columbia Valley
    5637151702: [
        {
            rating: '89 points',
            source: 'Wine Spectator',
            date: '9.1.16'
        },
        {
            rating: '88 points',
            source: 'Wine Spectator',
            date: '5.31.17'
        }
    ],

    // 14 Hands | Brut, Columbia Valley
    5637151703: [
        {
            rating: '89 Points',
            source: 'Wine Enthusiast',
            date: '5.1.16'
        }
    ],

    // 14 Hands: 2020 Sauvignon Blanc, Washington State
    5637348577: [
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '4.20.22'
        }
    ],

    //=======================================================================
    // NORTHSTAR
    //=======================================================================

    // Northstar: 2013 Merlot Columbia Valley , Columbia Valley
    5637151544: [
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '10.15.16'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        }
    ],

    // Northstar: 2013 Merlot Columbia Valley , Columbia Valley
    5637151668: [
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '10.15.16'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        }
    ],

    // Northstar: 2014 Merlot Columbia Valley, Columbia Valley
    5637151626: [
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '91 Points',
            source: 'Jeb Dunnuck',
            date: '4.5.18'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        }
    ],

    // Northstar: 2014 Red Wine Blend Walla Walla Valley, Walla Walla Valley
    5637151629: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        }
    ],

        // Northstar: 2021 Red Wine Blend Walla Walla Valley, Walla Walla Valley
    5637726599: [
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '11.1.24'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '7.11.24'
        }
    ],

    // Northstar: 2022 Red Wine Blend Walla Walla Valley, Walla Walla Valley
    5637794082: [
        {
            rating: '93 Points',
            source: 'Wine Enthusiast',
            date: '10.31.25'
            },
        {
            rating: '92 Points',
            source: 'Owen Bargreen',
            date: '8.18.25'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        }
    ],

    // Northstar: 2015 Merlot Columbia Valley, Columbia Valley
    5637151719: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '90 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        }
    ],

        // Northstar: 2022 Merlot Columbia Valley, Columbia Valley
    5637725834: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '8.18.25'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.31.25'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '10.31.25'
        }
    ],

    // Northstar: 2015 Premier Merlot, Columbia Valley
    5637151721: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '91 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        }
    ],

    // Northstar: 2018 Premier Merlot, Columbia Valley
    5637341834: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '10.31.22'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '7.1.23'
        }
    ],

        // Northstar: 2019 Premier Merlot, Columbia Valley
    5637479095: [
        {
            rating: '93+ Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        }
    ],

            // Northstar: 2021 Premier Merlot, Columbia Valley
    5637690578: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '4.3.25'
        }
    ],

                // Northstar: 2022 Premier Merlot, Columbia Valley
    5637764830: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '8.18.25'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '91 Points',
            source: 'Jeb Dunnuck',
            date: '7.10.25'
        }
    ],

                    // Northstar: 2023 Premier Merlot, Columbia Valley
    5637794081: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        }
    ],

        // Northstar: 2023 Premier Cabernet Sauvignon, Columbia Valley
    5637794080: [
        {
            rating: '92+ Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        }
    ],

                    // Northstar: 2022 Premier Cabernet Sauvignon, Columbia Valley
    5637764828: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '8.18.25'
        },
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '93 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '10.31.25'
        }
    ],

    // Northstar: 2015 Red Wine Blend Walla Walla Valley, Walla Walla Valley
    5637151722: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.1.18'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Northstar: 2015 Cabernet Sauvignon Walla Walla Valley, Walla Walla Valley
    5637151723: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '10.1.18'
        },
        {
            rating: '90 Points',
            acclaim: 'Year\'s Best US Cabernet/Blends',
            source: 'Wine & Spirits',
            date: '12.1.18'
        }
    ],

    // Northstar: 2014 Cabernet Sauvignon Walla Walla Valley, Walla Walla Valley
    5637151686: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        }
    ],

    // Northstar: 2019 Cabernet Sauvignon Columbia Valley, Columbia Valley
    5637423590: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '2.22.24'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '7.1.23'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '9.1.23'
        }
    ],

    // Northstar: 2015 Cabernet Sauvignon Columbia Valley, Columbia Valley
    5637151720: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        }
    ],

    // Northstar: 2014 Cabernet Sauvignon Columbia Valley, Columbia Valley
    5637151627: [
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '8.31.17'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Northstar: 2014 Syrah, Walla Walla Valley
    5637151622: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '93 Points',
            source: 'Wine & Spirits',
            date: '10.1.17'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '4.5.18'
        }
    ],

    // Northstar: 2009 Merlot, Columbia Valley
    5637151494: [
        {
            rating: '92 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '4.1.13'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.28.13'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '11.20.13'
        }
    ],

    // Northstar: 2010 Merlot, Columbia Valley
    5637151481: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.27.14'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '3.1.15'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '9.30.13'
        }
    ],

    // Northstar: 2012 Merlot, Columbia Valley
    5637151501: [
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.1.15'
        }
    ],

    // Northstar: 2010 Cabernet Sauvignon, Columbia Valley
    5637159621: [
        {
            rating: '93 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '3.1.14'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.28.13'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '9.30.13'
        }
    ],

    // Northstar: 2012 Cabernet Sauvignon, Columbia Valley
    5637159624: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '11.1.15'
        },
        {
            rating: '91 Points',
            source: 'International Wine Cellar',
            date: '11.15.15'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.15.15'
        }
    ],

    // Northstar: 2013 Cabernet Sauvignon, Columbia Valley
    5637151545: [
        {
            rating: '93 Points',
            source: 'Wine Spectator',
            date: '10.15.16'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        }
    ],

    // Northstar: 2011 Red Wine Blend, Walla Walla Valley
    5637151496: [
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.29.15'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '8.31.15'
        }
    ],

    // Northstar: 2012 Red Wine Blend, Walla Walla Valley
    5637151500: [
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.31.15'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.1.15'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        }
    ],

    // Northstar: 2009 Premier Merlot, Columbia Valley
    5637151475: [
        {
            rating: '94 Points',
            source: 'The Wine Advocate',
            date: '6.28.13'
        }
    ],

    // Northstar: 2010 Premier Merlot, Columbia Valley
    5637151478: [
        {
            rating: '95 Points',
            source: 'The Wine Advocate',
            date: '6.27.14'
        },
        {
            rating: '93 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '3.1.15'
        },
        {
            rating: '91+ Points',
            source: 'International Wine Cellar',
            date: '11.15.13'
        }
    ],

    // Northstar: 2011 Premier Merlot, Columbia Valley
    5637151492: [
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.29.15'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '11.1.15'
        }
    ],

    // Northstar: 2012 Premier Merlot, Columbia Valley
    5637151502: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '11.29.16'
        }
    ],

    // Northstar: 2013 Premier Merlot, Columbia Valley
    5637151546: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        }
    ],

    // Northstar: 2014 Premier Merlot, Columbia Valley
    5637151628: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.5.18'
        },
        {
            rating: '92 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Northstar: 2016 Premier Merlot, Columbia Valley
    5637151850: [
        {
            rating: '94+ Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '94+ Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        },
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '4.20.20'
        }
    ],

    // Northstar: 2017 Premier Merlot, Columbia Valley
    5637237579: [
        {
            rating: '94 Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.22.21'
        },
        {
            rating: '91+ Points',
            source: 'Vinous Media',
            date: '12.3.20'
        }
    ],

    // Northstar: 2016 Cabernet Sauvignon, Walla Walla Valley
    5637151851: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '93+ Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        }
    ],

    // Northstar: 2017 Cabernet Sauvignon, Walla Walla Valley
    5637182840: [
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '12.31.20'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '6.22.21'
        }
    ],

    // Northstar: 2018 Cabernet Sauvignon, Walla Walla Valley
    5637287078: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '7.8.21'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '12.1.21'
        }
    ],

        // Northstar: 2021 Cabernet Sauvignon, Walla Walla Valley
    5637653076: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '4.3.25'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.16.24'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '11.1.24'
        }
    ],

    // Northstar: 2016 Cabernet Sauvignon, Columbia Valley
    5637151852: [
        {
            rating: '96 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        }
    ],

    // Northstar: 2017 Cabernet Sauvignon, Columbia Valley
    5637182841: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '6.22.21'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.31.20'
        },
        {
            rating: '91 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        }
    ],

    // Northstar: 2018 Cabernet Sauvignon, Columbia Valley
    5637287079: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '3.31.23'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '91 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '90+ Points',
            source: 'The Wine Advocate',
            date: '10.31.22'
        },
        {
            rating: '90 Points',
            source: 'Wine & Spirits',
            date: '12.1.21'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '12.1.22'
        }
    ],

    // Northstar: 2020 Cabernet Sauvignon, Columbia Valley
    5637491077: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        }
    ],

    // Northstar: 2021 Cabernet Sauvignon, Columbia Valley
    5637653077: [
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '7.11.24'
       },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '11.1.24'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        }
    ],

    // Northstar: 2016 Red Wine Blend, Walla Walla Valley
    5637151853: [
        {
            rating: '93+ Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        },
        {
            rating: '92 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '8.1.19'
        },
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        }
    ],

    // Northstar: 2017 Red Wine Blend, Walla Walla Valley
    5637341837: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '12.3.20'
        }
    ],

    // Northstar: 2018 Red Wine Blend, Walla Walla Valley
    5637341836: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '7.8.21'
        },
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '12.1.21'
        },
        {
            rating: '91 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.1.22'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '3.31.23'
        }
    ],

    // Northstar: 2019 Red Wine Blend, Walla Walla Valley
    5637586347: [
        {
            rating: '92 Points',
            acclaim: 'Editors\' Choice',
            source: 'Wine Enthusiast',
            date: '7.1.23'
        }
    ],

    // Northstar: 2020 Red Wine Blend, Walla Walla Valley
    5637672603: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        }
    ],

    // Northstar: 2016 Merlot, Columbia Valley
    5637151849: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '11.30.19'
        }
    ],

    // Northstar: 2017 Merlot, Columbia Valley
    5637237578: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '6.22.21'
        },
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '91 Points',
            acclaim: 'Editors\' Choice',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        }
    ],

    // Northstar: 2018 Merlot, Columbia Valley
    5637341835: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '10.31.22'
        }
    ],

    // Northstar: 2019 Merlot, Columbia Valley
    5637403326: [
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        }

      ],

      // Northstar: 2020 Merlot, Columbia Valley
    5637548081: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        }

              ],

    // Northstar: 2021 Merlot, Columbia Valley
    5637645578: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '91 Points',
            source: 'Jeb Dunnuck',
            date: '7.11.24'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '11.1.24'
},
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '4.3.25'
}

              ],

      // Northstar: 2020 Dionysus Vineyard Cabernet Sauvignon
    5637587087: [
        {
            rating: '95 Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        }
        ],

          // Northstar: 2021 Dionysus Vineyard Cabernet Sauvignon
    5637672604: [
        {
            rating: '93 Points',
            source: 'Wine Enthusiast',
            date: '11.1.24'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '4.3.25'
        }
        ],

    //=======================================================================
    // SPRING VALLEY
    //=======================================================================

        // Spring Valley Vineyard: 2015 Frederick Red Wine, Walla Walla Valley
    5637151728: [
        {
            rating: '93 Points',
            acclaim: 'Top Wines',
            source: 'Wine Spectator',
            date: '8.31.18'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        }
    ],

    // Spring Valley Vineyard: 2016 Uriah Red Wine, Walla Walla Valley
    5637151828: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '10.1.19'
        }
    ],

    // Spring Valley Vineyard: 2017 Uriah Red Wine, Walla Walla Valley
    5637182847: [
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '6.30.21'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '3.1.21'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        }
    ],

    // Spring Valley Vineyard: 2009 Uriah Red Wine, Walla Walla Valley
    5637329088: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.28.13'
        }
    ],

    // Spring Valley Vineyard: 2010 Uriah Red Wine, Walla Walla Valley
    5637158831: [
        {
            rating: '94 Points',
            acclaim: 'Top 100 Wines of 2013',
            source: 'Wine Spectator',
            date: '12.1.13'
        },
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.27.14'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '3.1.14'
        }
    ],

    // Spring Valley Vineyard: 2011 Uriah Red Wine, Walla Walla Valley
    5637159671: [
        {
            rating: '92 Points',
            source: 'Wine & Spirits',
            date: '2.1.15'
        },
        {
            rating: '91 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '3.1.15'
        },
        {
            rating: '91+ Points',
            source: 'International Wine Cellar',
            date: '12.1.14'
        }
    ],

    // Spring Valley Vineyard: 2012 Uriah Red Wine, Walla Walla Valley
    5637158835: [
        {
            rating: '93 Points',
            acclaim: 'Editors\' Choice',
            source: 'Wine Enthusiast',
            date: '11.1.15'
        },
        {
            rating: '93 Points',
            source: 'Wine Spectator',
            date: '8.5.15'
        },
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.29.15'
        }
    ],

    // Spring Valley Vineyard: 2013 Uriah Red Wine, Walla Walla Valley
    5637158836: [
        {
            rating: '93 Points',
            source: 'Wine Spectator',
            date: '10.15.16'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '11.29.16'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        }
    ],

    // Spring Valley Vineyard: 2014 Uriah Red Wine, Walla Walla Valley
    5637159676: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '93 Points',
            source: 'Wine Spectator',
            date: '5.10.17'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        }
    ],

    // Spring Valley Vineyard: 2015 Uriah Red Wine, Walla Walla Valley
    5637151724: [
        {
            rating: '93 Points',
            acclaim: 'Year\'s Best US Cabernet/Blends',
            source: 'Wine & Spirits',
            date: '12.1.18'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Spring Valley Vineyard: 2018 Uriah Red Wine, Walla Walla Valley
    5637287090: [
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '3.21.23'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '90+ Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        }
    ],

        // Spring Valley Vineyard: 2019 Uriah Red Wine, Walla Walla Valley
    5637439348: [
        {
            rating: '94 Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '12.18.23'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '10.1.23'
        }
    ],

    // Spring Valley Vineyard: 2021 Uriah Red Wine, Walla Walla Valley
    5637559330: [
                {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '7.11.24'
        },
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '10.22.24'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '12.23.24'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '4.3.25'
        }
    ],

        // Spring Valley Vineyard: 2022 Uriah Red Wine, Walla Walla Valley
    5637661336: [
                {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '8.19.25'
        },
        {
        rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '7.10.25'
        },
        {
        rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.31.25'
    },
        {
        rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '2.28.26'
    },
        {
        rating: '92 Points',
            source: 'Wine Spectator',
            date: '12.22.25'
    },
        {
        rating: '91 Points',
            source: 'Vinous Media',
            date: '10.23.25'
    }
        ],

    // Spring Valley Vineyard: 2016 Nina Lee Syrah, Walla Walla Valley
    5637151857: [
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '12.3.19'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '92 Points',
            acclaim: 'Year\'s Best US Syrah & Rhone',
            source: 'Wine & Spirits',
            date: '2.1.20'
        }
    ],

    // Spring Valley Vineyard: 2015 Nina Lee Syrah, Walla Walla Valley
    5637151730: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Spring Valley Vineyard: 2013 Nina Lee Syrah, Walla Walla Valley
    5637151537: [
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '12.15.16'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '11.29.16'
        }
    ],

    // Spring Valley Vineyard: 2012 Nina Lee Syrah, Walla Walla Valley
    5637151504: [
        {
            rating: '93 Points',
            source: 'Wine Spectator',
            date: '8.5.15'
        },
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.29.15'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '11.1.15'
        }
    ],

    // Spring Valley Vineyard: 2016 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637151832: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '91+ Points',
            source: 'Vinous Media',
            date: '12.3.19'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        }
    ],

    // Spring Valley Vineyard: 2015 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637151726: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '10.1.18'
        }
    ],

    // Spring Valley Vineyard: 2014 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637151630: [
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '10.1.17'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Spring Valley Vineyard: 2013 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637151535: [
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '11.29.16'
        }
    ],

    // Spring Valley Vineyard: 2012 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637159674: [
        {
            rating: '93 Points',
            acclaim: 'Editors\'s Choice',
            source: 'Wine Enthusiast',
            date: '11.1.15'
        },
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.29.15'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.1.15'
        }
    ],

    // Spring Valley Vineyard: 2011 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637158833: [
        {
            rating: '90+ Points',
            source: 'International Wine Cellar',
            date: '12.1.14'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '12.15.14'
        }
    ],

    // Spring Valley Vineyard: 2015 Derby Cabernet Sauvignon, Walla Walla Valley
    5637151729: [
        {
            rating: '92+ Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Spring Valley Vineyard: 2013 Derby Cabernet Sauvignon, Walla Walla Valley
    5637159675: [
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '11.29.16'
        }
    ],

    // Spring Valley Vineyard: 2014 Derby Cabernet Sauvignon, Walla Walla Valley
    5637159679: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '91+ Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '91+ Points',
            source: 'Vinous Media',
            date: '10.1.17'
        }
    ],

    // Spring Valley Vineyard: 2014 Mule Skinner Merlot, Walla Walla Valley
    5637159677: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Spring Valley Vineyard: 2016 Mule Skinner Merlot, Walla Walla Valley
    5637151829: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        }
    ],

    // Spring Valley Vineyard: 2017 Mule Skinner Merlot, Walla Walla Valley
    5637151955: [
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '5.16.18'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '6.30.17'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '10.1.17'
        }
    ],

    // Spring Valley Vineyard: 2018 Mule Skinner Merlot, Walla Walla Valley
    5637224838: [
        {
            rating: '92 Points',
            acclaim: 'Editors\' Choice',
            source: 'Wine Enthusiast',
            date: '3.1.22'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        }
    ],

    // Spring Valley Vineyard: 2010 Sharilee Petit Verdot, Walla Walla Valley
    5637158832: [
        {
            rating: '91 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '4.1.13'
        }
    ],

    // Spring Valley Vineyard: 2015 Sharilee Petit Verdot, Walla Walla Valley
    5637151727: [
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Spring Valley Vineyard: 2016 Sharilee Petit Verdot, Walla Walla Valley
    5637151833: [
        {
            rating: '90+ Points',
            source: 'Vinous Media',
            date: '12.3.19'
        }
    ],

    // Spring Valley Vineyard: 2017 Sharilee Petit Verdot, Walla Walla Valley
    5637151957: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '91+ Points',
            source: 'Vinous Media',
            date: '12.3.20'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '7.8.21'
        }
    ],

    // Spring Valley Vineyard: 2018 Sharilee Petit Verdot, Walla Walla Valley
    5637229327: [
        {
            rating: '92 Points',
            acclaim: 'Editors\' Choice',
            source: 'Wine Enthusiast',
            date: '3.1.22'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '90+ Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        }
    ],

    // Spring Valley Vineyard: 2014 Nina Lee Syrah, Walla Walla Valley
    5637151632: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '10.1.17'
        }
    ],

    // Spring Valley Vineyard: 2017 Nina Lee Syrah, Walla Walla Valley
    5637151959: [
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '12.3.20'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '90 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        }
    ],

    // Spring Valley Vineyard: 2018 Nina Lee Syrah, Walla Walla Valley
    5637229326: [
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '12.31.22'
        },
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '2.28.22'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        }
    ],

    // Spring Valley Vineyard: 2019 Nina Lee Syrah, Walla Walla Valley
    5637449082: [
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            acclaim: 'Cellar Selection',
            date: '10.1.23'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '11.27.23'
        }
    ],

        // Spring Valley Vineyard: 2021 Nina Lee Syrah, Walla Walla Valley
    5637581845: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '10.22.24'
        },
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '7.11.24'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '4.3.25'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        }
    ],

          // Spring Valley Vineyard: 2022 Nina Lee Syrah, Walla Walla Valley
    5637677827: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '8.19.25'
        },
        {
            rating: '93 Points',
            source: 'Wine Enthusiast',
            date: '2.28.26'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.31.25'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        }
        ],

    // Spring Valley Vineyard: 2017 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637151956: [
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '7.8.21'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.31.20'
        }
    ],

    // Spring Valley Vineyard: 2018 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637224837: [
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '91 Points',
            acclaim: 'Editors\' Choice',
            source: 'Wine Enthusiast',
            date: '3.1.22'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        },
        {
            rating: '90+ Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        }
    ],

        // Spring Valley Vineyard: 2019 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637439347: [
        {
            rating: '92+ Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '10.1.23'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        }
    ],

    // Spring Valley Vineyard: 2021 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637559329: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '10.22.24'
        },
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '7.11.24'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '2.22.24'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '4.3.25'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        }
    ],

      // Spring Valley Vineyard: 2022 Katherine Corkrum Cabernet Franc, Walla Walla Valley
    5637661335: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '8.19.25'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.31.25'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '2.28.26'
        }
        ],

    // Spring Valley Vineyard: 2010 Frederick Red Wine, Walla Walla Valley
    5637158834: [
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '10.16.13'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '6.27.14'
        },
        {
            rating: '90 Points',
            source: 'Wine & Spirits',
            date: '12.31.13'
        }
    ],

    // Spring Valley Vineyard: 2012 Frederick Red Wine, Walla Walla Valley
    5637298345: [
        {
            rating: '94 Points',
            source: 'The Wine Advocate',
            date: '6.29.15'
        },
        {
            rating: '93 Points',
            source: 'Wine Spectator',
            date: '8.5.15'
        },
        {
            rating: '93 Points',
            source: 'Wine & Spirits',
            date: '10.1.15'
        }
    ],

    // Spring Valley Vineyard: 2013 Frederick Red Wine, Walla Walla Valley
    5637298346: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '11.29.16'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '10.31.16'
        }
    ],

    // Spring Valley Vineyard: 2014 Frederick Red Wine, Walla Walla Valley
    5637151631: [
        {
            rating: '94 Points',
            acclaim: 'Top 100 of 2017 (#39)',
            source: 'Wine Spectator',
            date: '12.31.17'
        },
        {
            rating: '92 Points',
            acclaim: 'Year\'s Best',
            source: 'Wine & Spirits',
            date: '12.15.17'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        }
    ],

    // Spring Valley Vineyard: 2016 Frederick Red Wine, Walla Walla Valley
    5637151855: [
        {
            rating: '92+ Points',
            source: 'Vinous Media',
            date: '12.3.19'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '10.31.19'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        }
    ],

    // Spring Valley Vineyard: 2017 Frederick Red Wine, Walla Walla Valley
    5637182846: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '93 Points',
            source: 'Wine Spectator',
            date: '7.31.21'
        },
        {
            rating: '92+ Points',
            source: 'Vinous Media',
            date: '12.3.20'
        }
    ],

    // Spring Valley Vineyard: 2018 Frederick Red Wine, Walla Walla Valley
    5637287089: [
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '3.31.23'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '3.1.22'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        }
    ],

    // Spring Valley Vineyard: 2019 Frederick Red Wine, Walla Walla Valley
    5637449083: [
        {
            rating: '93 Points',
            source: 'Wine Enthusiast',
            acclaim: 'Editor\'s Choice',
            date: '10.1.23'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.11.23'
        }
    ],

        // Spring Valley Vineyard: 2021 Frederick Red Wine, Walla Walla Valley
    5637581843: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '2.22.24'
        },
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '10.22.24'
        },
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '4.3.25'
        },
        {
            rating: '92+ Points',
            source: 'Jeb Dunnuck',
            date: '7.11.24'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.23.24'
        }
    ],

     // Spring Valley Vineyard: 2022 Frederick Red Wine, Walla Walla Valley
    5637677828: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '8.20.25'
        },
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '7.10.25'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '3.31.25'
        },
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '93 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '2.28.26'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '12.22.25'
         }
    ],

    // Spring Valley Vineyard: 2016 Derby Cabernet Sauvignon, Walla Walla Valley
    5637151856: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '92+ Points',
            source: 'Vinous Media',
            date: '12.3.19'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        }
    ],

    // Spring Valley Vineyard: 2017 Derby Cabernet Sauvignon, Walla Walla Valley
    5637160387: [
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '3.1.21'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '12.3.20'
        }
    ],

    // Spring Valley Vineyard: 2018 Derby Cabernet Sauvignon, Walla Walla Valley
    5637287088: [
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '7.9.22'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '3.31.23'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        }
    ],

    // Spring Valley Vineyard: 2019 Viognier, Walla Walla Valley
    5637280338: [
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '12.3.20'
        }
    ],

    // Spring Valley Vineyard: 2014 Syrah, Walla Walla Valley
    5637151745: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Spring Valley Vineyard: 2014 Malbec, Walla Walla Valley
    5637329087: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        }
    ],

    //=======================================================================
    // COLUMBIA CREST
    //=======================================================================

// Columbia Crest: 2019 Reserve Walter Clore Red Wine, Columbia Valley
    5637559328: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.5.23'
        }
    ],

    // Columbia Crest: 2021 Reserve Cabernet Sauvignon Heart of the Hill Vineyard, Red Mountain
    5637654578: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '2.22.24'
       },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '10.31.24'
        }
    ],

        // Columbia Crest: 2021 Reserve Walter Clore Red Wine, Columbia Valley
    5637672588: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '5.29.24'
        },
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        }
    ],

    // Columbia Crest: 2018 Reserve Walter Clore Red Wine, Columbia Valley
    5637544328: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '5.30.23'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        }
    ],

    // Columbia Crest: 2017 Reserve Walter Clore Red Wine, Columbia Valley
    5637323842: [
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '91+ Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '4.1.22'
        }
    ],

    // Columbia Crest: 2013 Reserve Walter Clore Red Wine, Columbia Valley
    5637151615: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        }
    ],

    // Columbia Crest: 2012 Reserve Walter Clore Red Wine, Columbia Valley
    5637151530: [
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '7.31.15'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.1.15'
        },
        {
            rating: '91 Points',
            source: 'International Wine Cellar',
            date: '11.15.15'
        }
    ],

    // Columbia Crest: 2015 Reserve Cabernet Sauvignon, Sportfisher Vineyard, Columbia Valley
    5637151787: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.5.18'
        }
    ],

    // Columbia Crest: 2018 Reserve Cabernet Sauvignon, Sportfisher Vineyard, Columbia Valley
    5637289326: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        }
    ],

    // Columbia Crest: 2019 Reserve Cabernet Sauvignon, Columbia Valley
    5637617827: [
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        }
    ],

    // Columbia Crest: 2013 Reserve Cabernet Sauvignon, Columbia Valley
    5637151614: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.5.18'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        }
    ],

    // Columbia Crest: 2012 Reserve Cabernet Sauvignon, Columbia Valley
    5637151529: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '11.30.15'
        },
        {
            rating: '90 Points',
            source: 'International Wine Cellar',
            date: '11.15.15'
        }
    ],

    // Columbia Crest: 2014 Reserve Cabernet Sauvignon Wautoma Springs Vineyard, Columbia Valley
    5637151692: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '5.1.18'
        }
    ],

    // Columbia Crest: 2015 Reserve Cabernet Sauvignon Wautoma Springs Clone 2, Columbia Valley
    5637151784: [
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '12.31.16'
        }
    ],

    // Columbia Crest: 2017 Reserve Cabernet Sauvignon Wautoma Springs Vineyard, Columbia Valley
    5637236080: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '2.28.22'
        }
    ],

    // Columbia Crest: 2018 Reserve Cabernet Sauvignon Wautoma Springs Vineyard, Columbia Valley
    5637320826: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        }
    ],

    // Columbia Crest: 2013 Reserve Cabernet Sauvignon Wautoma Springs Vineyard, Columbia Valley
    5637151595: [
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '7.31.16'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '9.1.16'
        }
    ],

    // Columbia Crest: 2014 Reserve Cabernet Sauvignon Cold Creek Vineyard, Columbia Valley
    5637151689: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        }
    ],

    // Columbia Crest: 2015 Reserve Cabernet Sauvignon Heart of the Hill Vineyard, Red Mountain
    5637151783: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Columbia Crest: 2018 Reserve Cabernet Sauvignon Heart of the Hill Vineyard, Red Mountain
    5637308101: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.14.21'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '10.5.21'
        },
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '91+ Points',
            source: 'The Wine Advocate',
            date: '10.14.21'
        }
    ],

    // Columbia Crest: 2019 Reserve Cabernet Sauvignon Heart of the Hill Vineyard, Red Mountain
    5637444619: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        },
        {
            rating: '93 Points',
            source: 'Wine & Spirits',
            date: '12.1.22'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.1.22'
        }
    ],

        // Columbia Crest: 2020 Reserve Cabernet Sauvignon Heart of the Hill Vineyard, Red Mountain
    5637548829: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.5.23'
        }
    ],

    // Columbia Crest: 2015 Reserve Malbec, Andrews & Rowell Vineyard, Horse Heaven Hills
    5637151779: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Columbia Crest: 2017 Reserve Malbec, Jones Vineyard, Wahluke Slope
    5637236081: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        }
    ],

    // Columbia Crest: 2016 Reserve Sauvignon Blanc Yakima Valley, Yakima Valley
    5637151766: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Columbia Crest: 2019 Reserve Syrah Anna Marie Vineyard
    5637535361: [
        {
            rating: '90 Points',
            acclaim: 'Year\'s Best US Rhone Varieties',
            source: 'Wine & Spirits',
            date: '4.1.23'
        }
    ],
    // Columbia Crest: 2019 Reserve Syrah Coyote Canyon Vineyard, Horse Heaven Hills
    5637437076: [
        {
            rating: '91 Points',
            acclaim: 'Year\'s Best US Rhone Varieties',
            source: 'Wine & Spirits',
            date: '4.1.23'
        }
    ],

    // Columbia Crest: 2016 Reserve Syrah Coyote Canyon Vineyard, Horse Heaven Hills
    5637151877: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        }
    ],

    // Columbia Crest: 2014 Reserve Syrah Coyote Canyon Vineyard, Horse Heaven Hills
    5637151682: [
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        }
    ],

    // Columbia Crest: 2013 Reserve Syrah Coyote Canyon Vineyard, Horse Heaven Hills
    5637151593: [
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '9.1.16'
        }
    ],

    // Columbia Crest: 2018 Reserve Red Wine Blend Coyote Canyon Vineyard, Horse Heaven Hills
    5637323843: [
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '1.1.22'
        },
        {
            rating: '90 Points',
            source: 'Jeb Dunnuck',
            date: '8.1.21'
        }
    ],

        // Columbia Crest: 2021 Reserve GSM Red Wine Blend, James Vineyard
    5637682334: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '5.29.24'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '10.31.24'
        }
    ],

    // Columbia Crest: 2016 Reserve Grenache, Horse Heaven Hills
    5637151886: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        }
    ],

    // Columbia Crest: 2014 Crowdsourced� Cabernet, Horse Heaven Hills
    5637151616: [
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '5.31.17'
        }
    ],

    // Columbia Crest: 2015 Reserve Chardonnay, Horse Heaven Hills
    5637151763: [
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '12.1.17'
        }
    ],

    // Columbia Crest: 2019 H3 Merlot, Horse Heaven Hills
    5637487327: [
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '3.1.23'
        }
    ],

    // Columbia Crest: 2016 H3 Cabernet Sauvignon, Horse Heaven Hills
    5637151823: [
        {
            rating: '90 Points',
            acclaim: 'Top Value',
            source: 'Wine Spectator',
            date: '8.31.18'
        }
    ],

    // Columbia Crest: 2019 H3 Cabernet Sauvignon, Horse Heaven Hills
    5637408588: [
        {
            rating: '90 Points',
            acclaim: 'Smart Buy',
            source: 'Wine Spectator',
            date: '2.3.22'
        },
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        }
    ],

    // Columbia Crest: 2020 H3 Cabernet Sauvignon, Horse Heaven Hills
    5637503839: [
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        }
    ],

    // Columbia Crest: 2020 H3 Rosé, Horse Heaven Hills
    5637359840: [
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            acclaim: 'Best Buy',
            date: '12.1.22'
        }
    ],

    // Columbia Crest: 2019 H3 Red Blend, Horse Heaven Hills
    5637470080: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '2.28.22'
        }
    ],

    // Columbia Crest: 2018 H3 Red Blend, Horse Heaven Hills
    5637250332: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '7.14.21'
        },
        {
            rating: '90 Points',
            acclaim: 'Top 100 Best Buys, Top 100 Values',
            source: 'Wine & Spirits',
            date: '1.1.22'
        }
    ],

    // Columbia Crest: 2018 H3 Red Blend label, Horse Heaven Hills
    5637314826: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '7.14.21'
        },
        {
            rating: '90 Points',
            acclaim: 'Top 100 Best Buys, Top 100 Values',
            source: 'Wine & Spirits',
            date: '1.1.22'
        }
    ],

    // Columbia Crest: 2020 H3 Sauvignon Blanc, Horse Heaven Hills
    5637466330: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        }
    ],

    // Columbia Crest: 2020 Grand Estates Merlot, Columbia Valley
    5637466331: [
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '3.1.23'
        },
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '4.5.23'
        }
    ],

        // Columbia Crest: 2021 Grand Estates Merlot, Columbia Valley
    5637593087: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '90 Points',
            source: 'Owen Bargreen',
            date: '5.29.24'
        }
    ],

    // Columbia Crest: 2022 Grand Estates Chardonnay, Columbia Valley
    5637644835: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '2.22.24'
        },
        {
            rating: '91 Points',
            source: 'Owen Bargreen',
            date: '5.29.24'
        },
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '10.31.24'
        }
    ],

    // Columbia Crest: 2021 Grand Estates Chardonnay, Columbia Valley
    5637464826: [
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '4.5.23'
        },
        {
            rating: '90 Points',
            source: 'Owen Bargreen',
            date: '5.30.23'
        }
    ],

    // Columbia Crest: 2016 Grand Estates Cabernet Sauvignon, Columbia Valley
    5637151820: [
        {
            rating: '86 Points',
            acclaim: 'Year\'s Best US Cabernet/Blends',
            source: 'Wine & Spirits',
            date: '12.1.18'
        }
    ],

        // Columbia Crest: 2018 Grand Estates Cabernet Sauvignon, Columbia Valley
    5637305109: [
        {
            rating: '92 Points',
            source: 'Wine & Spirits',
            date: '2.28.22'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        }
    ],

            // Columbia Crest: 2020 Grand Estates Cabernet Sauvignon, Columbia Valley
    5637478346: [
        {
            rating: '90 Points',
            source: 'Owen Bargreen',
            date: '5.30.23'
        }
    ],

    // Columbia Crest: 2017 Grand Estates Syrah, Columbia Valley
    5637151936: [
        {
            rating: '87 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '7.1.19'
        }
    ],

    // Columbia Crest: 2020 Grand Estates Syrah, Columbia Valley
    5637473083: [
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '3.1.23'
        }
    ],

        // Columbia Crest: 2021 Grand Estates Syrah, Columbia Valley
    5637682326: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '10.31.24'
        }
    ],

        //=======================================================================
    // CHATEAU STE MICHELLE
    //=======================================================================

        // Domaine Ste. Michelle: 2017 Luxe, Columbia Valley
    5637527829: [
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine & Spirits',
            date: '7.5.23'
        }
    ],

    // Domaine Ste. Michelle: 2016 Luxe, Columbia Valley
    5637287087: [
        {
            rating: '90 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '12.1.21'
        }
    ],

    // Domaine Ste. Michelle: 2014 Luxe, Columbia Valley
    5637144600: [
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        }
    ],

    // Domaine Ste. Michelle: 2013 Luxe, Columbia Valley
    5637161160: [
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        }
    ],

    // Chateau Ste. Michelle: 2015 IMPETUS Red Wine, Columbia Valley
    5637161279: [
        {
            rating: '94+ Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        },
        {
            rating: '94 Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        }
    ],

        // Chateau Ste. Michelle: 2015 IMPETUS Red Wine, Columbia Valley
    5637184330: [
        {
            rating: '94+ Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        },
        {
            rating: '94 Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        }
    ],

    // Chateau Ste. Michelle: 2014 IMPETUS Red Wine, Columbia Valley
    5637161123: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '4.5.18'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '2.1.18'
        }
    ],

        // Chateau Ste. Michelle: 2022 Artist Series Red Wine
    5637732585: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '8.20.25'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        }
    ],

         // Chateau Ste. Michelle: 2022 Artist Series Red Wine
    5637732586: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '8.20.25'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        }
    ],

        // Chateau Ste. Michelle: 2022 Artist Series Red Wine
    5637732587: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '8.20.25'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        }
    ],

        // Chateau Ste. Michelle: 2021 Artist Series Red Wine - Boom Flow Glow Label, Columbia Valley
    5637682332: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        }
    ],

         // Chateau Ste. Michelle: 2021 Artist Series Red Wine - Chambers Baptism Label, Columbia Valley
    5637682333: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        }
    ],

        // Chateau Ste. Michelle: 2021 Artist Series Red Wine - Nourished Nature Label, Columbia Valley
    5637682331: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        }
    ],

        // Chateau Ste. Michelle: 2020 Artist Series Red Wine - Accord Label, Columbia Valley
    5637574332: [
        {
            rating: '91 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        }
    ],

         // Chateau Ste. Michelle: 2020 Artist Series Red Wine - Continuum Label, Columbia Valley
    5637576577: [
        {
            rating: '91 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        }
    ],

        // Chateau Ste. Michelle: 2020 Artist Series Red Wine - Feed Backing Label, Columbia Valley
    5637576578: [
        {
            rating: '91 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        }
    ],


// Chateau Ste. Michelle: 2015 Artist Series Red Wine - Vita Galileo Label, Columbia Valley
    5637233087: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        }
    ],

    // Chateau Ste. Michelle: 2015 Artist Series Red Wine - Blessing Label, Columbia Valley
    5637161180: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        }
    ],

    // Chateau Ste. Michelle: 2015 Artist Series Red Wine - Source Label, Columbia Valley
    5637161214: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        }
    ],

    // Chateau Ste. Michelle: 2015 Artist Series Red Wine - Source Label 1.5L, Columbia Valley
    5637161187: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        }
    ],

    // Chateau Ste. Michelle: 2014 Artist Series Red Wine - Mathematical Equation Label, Columbia Valley
    5637161119: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.5.18'
        },
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '10.1.17'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        }
    ],

    // Chateau Ste. Michelle: 2013 Artist Series Red Wine - Etch Glyph Label, Columbia Valley
    5637161104: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '9.21.16'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.1.16'
        }
    ],

    // Chateau Ste. Michelle: 2012 Artist Series Red Wine - Close Label, Columbia Valley
    5637161090: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.29.15'
        },
        {
            rating: '92+ Points',
            source: 'International Wine Cellar',
            date: '11.15.15'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '12.15.15'
        }
    ],

    // Chateau Ste. Michelle: 2011 Artist Series Meritage, Columbia Valley
    5637161096: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.27.14'
        },
        {
            rating: '92 Points',
            source: 'International Wine Cellar',
            date: '12.1.14'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '5.1.15'
        }
    ],

    // Chateau Ste. Michelle: 2000 Artist Series Meritage, Columbia Valley
    5637243584: [
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '12.31.03'
        }
    ],

    // Chateau Ste. Michelle: 2001 Artist Series Meritage, Columbia Valley
    5637243578: [
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '8.30.04'
        }
    ],

    // Chateau Ste. Michelle: 2003 Artist Series Meritage, Columbia Valley
    5637243580: [
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '6.15.06'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '4.23.06'
        }
    ],

    // Chateau Ste. Michelle: 2006 Artist Series Meritage Spring Label, Columbia Valley
    5637368082: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.31.01'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '10.31.09'
        }
    ],

    // Chateau Ste. Michelle: 2006 Artist Series Meritage Shoreline II Label, Columbia Valley
    5637368083: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.31.01'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '10.31.09'
        }
    ],

    // Chateau Ste. Michelle: 2006 Artist Series Meritage Shoreline III Label, Columbia Valley
    5637368084: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.31.01'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '10.31.09'
        }
    ],

    // Chateau Ste. Michelle: 2008 Artist Series Meritage Butterfly Label, Columbia Valley
    5637370332: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.31.11'
        },
                {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '11.31.11'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '9.30.11'
        }
    ],

    // Chateau Ste. Michelle: 2008 Artist Series Meritage Carousel Label, Columbia Valley
    5637370333: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.31.11'
        },
                {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '11.31.11'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '9.30.11'
        }
    ],

    // Chateau Ste. Michelle: 2008 Artist Series Meritage La Bruja Label, Columbia Valley
    5637370331: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.31.11'
        },
                {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '11.31.11'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '9.30.11'
        }
    ],

    // Chateau Ste. Michelle: 2015 Ethos Reserve Cabernet Sauvignon, Columbia Valley
    5637159577: [
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '8.31.18'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '11.1.19'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Chateau Ste. Michelle: 2017 Ethos Reserve Cabernet Sauvignon, Columbia Valley
    5637308081: [
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
       {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        },
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '12.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2014 Ethos Reserve Cabernet Sauvignon, Columbia Valley
    5637159684: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '90+ Points',
            source: 'Vinous Media',
            date: '10.1.17'
        }
    ],

    // Chateau Ste. Michelle: 2013 Ethos Reserve Cabernet Sauvignon, Columbia Valley
    5637161099: [
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '5.16.18'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '11.15.16'
        }
    ],

    // Chateau Ste. Michelle: 2016 Ethos Reserve Chardonnay, Columbia Valley
    5637161173: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.18'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Chateau Ste. Michelle: 2015 Ethos Reserve Chardonnay, Columbia Valley
    5637160353: [
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '10.30.17'
        }
    ],

    // Chateau Ste. Michelle: 2013 Ethos Reserve Merlot, Columbia Valley
    5637160354: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '8.1.17'
        }
    ],

    // Chateau Ste. Michelle: 2013 Ethos Reserve Syrah, Columbia Valley
    5637161100: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.30.16'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '11.29.16'
        }
    ],

    // Chateau Ste. Michelle: 2016 Red Mountain Cabernet Sauvignon, Red Mountain
    5637160369: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.4.19'
        },
        {
            rating: '92+ Points',
            source: 'The Wine Advocate',
            date: '12.30.19'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '5.28.19'
        }
    ],

        // Chateau Ste. Michelle: 2018 Red Mountain Cabernet Sauvignon, Red Mountain
    5637447576: [
        {
            rating: '93 Points',
            source: 'Wine & Spirits',
            date: '12.1.22'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '11.17.22'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '3.1.23'
        }
    ],

    // Chateau Ste. Michelle: 2019 Red Mountain Cabernet Sauvignon, Red Mountain
    5637581842: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '10.1.23'
        }
    ],

        // Chateau Ste. Michelle: 2021 Red Mountain Cabernet Sauvignon, Red Mountain
    5637704077: [
         {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '3.31.25'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '12.5.24'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.30.24'
        },
        {
            rating: '90 Points',
            source: 'Jeb Dunnuck',
            date: '7.10.25'
        }
    ],

    // Chateau Ste. Michelle: 2015 Canoe Ridge Estate Cabernet Sauvignon, Horse Heaven Hills
    5637159682: [
        {
            rating: '91 Points',
            acclaim: 'Best Buy',
            source: 'Wine & Spirits',
            date: '10.1.18'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '6.1.18'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '11.16.18'
        }
    ],

    // Chateau Ste. Michelle: 2023 Canoe Ridge Estate Chardonnay, Horse Heaven Hills
    5637794084: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '8.20.25'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '10.31.25'
        }
    ],

        // Chateau Ste. Michelle: 2022 Canoe Ridge Estate Chardonnay, Horse Heaven Hills
    5637754333: [
        {
            rating: '92 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        },
        {
            rating: '92 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '9.1.25'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.31.25'
        }

    ],

        // Chateau Ste. Michelle: 2021 Canoe Ridge Estate Chardonnay, Horse Heaven Hills
    5637485077: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        }
    ],

        // Chateau Ste. Michelle: 2020 Canoe Ridge Estate Chardonnay, Horse Heaven Hills
    5637497836: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '6.1.23'
        }
    ],

    // Chateau Ste. Michelle: 2016 Canoe Ridge Estate Chardonnay, Horse Heaven Hills
    5637160364: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '90 Points',
            acclaim: 'Year\'s Best Chardonnays',
            source: 'Wine & Spirits',
            date: '10.1.19'
        },
        {
            rating: '90 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        }
    ],

    // Chateau Ste. Michelle: 2022 Canoe Ridge Estate Merlot, Horse Heaven Hills
    5637752086: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '10.31.25'
        },
        {
            rating: '90 Points',
            source: 'Jeb Dunnuck',
            date: '7.10.25'
        }
    ],

    // Chateau Ste. Michelle: 2014 Canoe Ridge Estate Merlot, Horse Heaven Hills
    5637161112: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '89 Points',
            source: 'Vinous Media',
            date: '10.1.17'
        }
    ],

        // Chateau Ste. Michelle: 2022 Canoe Ridge Estate Cabernet Sauvignon, Horse Heaven Hills
    5637794083: [
        {
            rating: '92 Points',
            source: 'Owen Bargreen',
            date: '8.20.25'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '10.31.25'
        }
    ],

            // Chateau Ste. Michelle: 2019 Canoe Ridge Estate Cabernet Sauvignon, Horse Heaven Hills
    5637516576: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '11.1.22'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '10.31.22'
        }
    ],

        // Chateau Ste. Michelle: 2022 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637794086: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.31.25'
        }
    ],

        // Chateau Ste. Michelle: 2021 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637773082: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '12.1.24'
        }
    ],

        // Chateau Ste. Michelle: 2021 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637732580: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        }
    ],

    // Chateau Ste. Michelle: 2015 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637159683: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Chateau Ste. Michelle: 2019 Cold Creek Vineyard Merlot, Columbia Valley
    5637548841: [
        {
            rating: '92 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        }
    ],

        // Chateau Ste. Michelle: 2013 Cold Creek Vineyard Merlot, Columbia Valley
    5637160361: [
        {
            rating: '90 Points',
            source: 'Wine & Spirits',
            date: '12.1.17'
        }
    ],

    // Chateau Ste. Michelle: 2022 Cold Creek Vineyard Riesling, Columbia Valley
    5637755078: [
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '12.1.24'
        }
    ],

        // Chateau Ste. Michelle: 2017 Cold Creek Vineyard Riesling, Columbia Valley
    5637161212: [
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Chateau Ste. Michelle: 2016 Cold Creek Vineyard Riesling, Columbia Valley
    5637161161: [
        {
            rating: '89 Points',
            source: 'Vinous Media',
            date: '10.1.17'
        }
    ],

    // Chateau Ste. Michelle: 2017 Horse Heaven Vineyard Sauvignon Blanc, Horse Heaven Hills
    5637157370: [
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '11.1.19'
        }
    ],

    // Chateau Ste. Michelle: 2022 Indian Wells Merlot, Columbia Valley
    5637794085: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.31.25'
        }
    ],

    // Chateau Ste. Michelle: 2022 Indian Wells Merlot, Columbia Valley
    5637745339: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.31.25'
        }
    ],

    // Chateau Ste. Michelle: 2016 Indian Wells Merlot, Columbia Valley
    5637160365: [
        {
            rating: '89 Points',
            acclaim: 'Smart Buy',
            source: 'Wine Spectator',
            date: '3.31.19'
        }
    ],

    // Chateau Ste. Michelle: 2019 Indian Wells Cabernet Sauvignon, Columbia Valley
    5637437876: [
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '12.1.22'
        }
    ],

        // Chateau Ste. Michelle: 2020 Indian Cabernet Sauvignon, Columbia Valley
    5637512829: [
        {
            rating: '91 Points',
            acclaim: 'Best Buy',
            source: 'Wine & Spirits',
            date: '7.5.23'
        }
    ],

        // Chateau Ste. Michelle: 2021 Indian Cabernet Sauvignon, Columbia Valley
    5637634329: [
        {
            rating: '92 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        }
    ],

    // Chateau Ste. Michelle: 2016 Indian Wells Red Wine Blend, Columbia Valley
    5637160366: [
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '9.30.19'
        },
        {
            rating: '88 Points',
            source: 'Wine & Spirits',
            date: '11.1.19'
        }
    ],

    // Chateau Ste. Michelle: 2018 Ros�, Columbia Valley
    5637160374: [
        {
            rating: '89+ Points',
            acclaim: 'Best Value',
            source: 'Wine Spectator',
            date: '8.31.19'
        }
    ],

    // Chateau Ste. Michelle: 2019 Merlot, Columbia Valley
    5637593090: [
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine & Spirits',
            date: '7.5.23'
        }
    ],

    // Chateau Ste. Michelle: 2020 Cabernet Sauvignon, Columbia Valley
    5637550327: [
        {
            rating: '91 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '10.11.23'
        }
    ],

    // Chateau Ste. Michelle: 2016 Cabernet Sauvignon, Columbia Valley
    5637160368: [
        {
            rating: '89 Points',
            source: 'Wine Spectator',
            date: '8.31.19'
        }
    ],

    // Chateau Ste. Michelle: 2015 Cabernet Sauvignon - Special Anniversary Bottling, Columbia Valley
    5637161162: [
        {
            rating: '89 Points',
            source: 'Wine Enthusiast',
            date: '9.1.17'
        },
        {
            rating: '88 Points',
            acclaim: 'Best Buy',
            source: 'Wine & Spirits',
            date: '10.1.17'
        }
    ],

    // Chateau Ste. Michelle: 2017 Chardonnay, Columbia Valley
    5637159689: [
        {
            rating: '89 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '10.1.19'
        }
    ],

    // Chateau Ste. Michelle: 2021 Le Rosé, Columbia Valley
    5637433326: [
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '8.1.22'
        }
    ],

        // Chateau Ste. Michelle: 2022 Le Rosé, Columbia Valley
    5637561578: [
        {
            rating: '92 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '6.26.23'
        }
    ],

    // Chateau Ste. Michelle: 2017 Riesling, Columbia Valley
    5637161210: [
        {
            rating: '89 Points',
            acclaim: 'Top Value',
            source: 'Wine Spectator',
            date: '8.31.18'
        },
        {
            rating: '89 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '3.1.19'
        }
    ],

    // Chateau Ste. Michelle: 2021 Dry Riesling, Columbia Valley
    5637422846: [
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '8.1.22'
        },
        {
            rating: '90 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        }
    ],

    // Chateau Ste. Michelle: 2017 Dry Riesling, Columbia Valley
    5637159687: [
        {
            rating: '89 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '3.1.19'
        },
        {
            rating: '88 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        },
        {
            rating: '87 Points',
            source: 'Wine & Spirits',
            date: '4.1.19'
        }
    ],

    // Chateau Ste. Michelle: 2015 Dry Riesling, Columbia Valley
    5637161110: [
        {
            rating: '89 Points',
            source: 'Wine Enthusiast',
            date: '12.31.16'
        }
    ],

    // Chateau Ste. Michelle: 2019 Cabernet Sauvignon, Columbia Valley
    5637464828: [
        {
            rating: '90 Points',
            source: 'Wine & Spirits',
            date: '12.1.22'
        }
    ],

    // Chateau Ste. Michelle: 2017 Sauvignon Blanc, Columbia Valley
    5637161211: [
        {
            rating: '89 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '3.1.19'
        },
        {
            rating: '87 Points',
            source: 'Wine & Spirits',
            date: '4.1.19'
        }
    ],

    // Chateau Ste. Michelle: 2014 Ethos Reserve Cabernet Sauvignon 1.5L
    5637165726: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '6.30.17'
        },
        {
            rating: '90+ Points',
            source: 'Vinous Media',
            date: '10.1.17'
        }
    ],

    // Chateau Ste. Michelle: 2015 Ethos Reserve Cabernet Sauvignon 1.5L
    5637282578: [
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '8.31.18'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '11.1.19'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Chateau Ste. Michelle: 2014 Eroica Ice Wine, Horse Heaven Hills
    5637161109: [
        {
            rating: '95 Points',
            source: 'Wine Spectator',
            date: '12.31.17'
        }
    ],

    // Chateau Ste. Michelle: Domaine Ste. Michelle Brut, Columbia Valley
    5637157374: [
                {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '12.1.15'
        },
        {
            rating: '89 Points',
            source: 'Wine Spectator',
            date: '6.15.15'
        },
        {
            rating: '87 Points',
            source: 'Wine Spectator',
            date: '2.1.16'
        }
    ],

    // Chateau Ste. Michelle: Domaine Ste. Michelle Brut Ros�, Columbia Valley
    5637159686: [
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '6.26.23'
        }
    ],

    // Chateau Ste. Michelle: Domaine Ste. Michelle Extra Dry, Columbia Valley
    5637159688: [
        {
            rating: '88 Points',
            source: 'Wine Spectator',
            date: '6.15.15'
        }
    ],

    // Chateau Ste. Michelle: 2016 Artist Series Red Wine, Columbia Valley
    5637166388: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        },
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '12.3.19'
        }
    ],

    // Chateau Ste. Michelle: 2016 Artist Series Red Wine, Columbia Valley
    5637161221: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        },
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '12.3.19'
        }
    ],

    // Chateau Ste. Michelle: 2016 Artist Series Red Wine, Columbia Valley
    5637161222: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        },
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '12.3.19'
        }
    ],

    // Chateau Ste. Michelle: 2016 Artist Series Red Wine, Columbia Valley
   5637166332: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        },
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '12.3.19'
        }
    ],

    // Chateau Ste. Michelle: 2017 Artist Series Red Wine, Columbia Valley
    5637225576: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '92 Points',
            source: 'Wine & Spirits',
            date: '12.1.20'
        }
    ],

    // Chateau Ste. Michelle: 2017 Artist Series Red Wine, Columbia Valley
    5637224829: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '92 Points',
            source: 'Wine & Spirits',
            date: '12.1.20'
        }
    ],

    // Chateau Ste. Michelle: 2017 Artist Series Red Wine, Columbia Valley
    5637230084: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '92 Points',
            source: 'Wine & Spirits',
            date: '12.1.20'
        }
    ],

    // Chateau Ste. Michelle: 2018 Artist Series Red Wine, Columbia Valley
    5637309584: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        },
        {
            rating: '94 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '5.1.22'
        }
    ],

    // Chateau Ste. Michelle: 2018 Artist Series Red Wine, Columbia Valley
    5637326828: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        },
        {
            rating: '94 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '5.1.22'
        }
    ],

    // Chateau Ste. Michelle: 2018 Artist Series Red Wine, Columbia Valley
    5637329085: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        },
        {
            rating: '94 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '5.1.22'
        }
    ],

    // Chateau Ste. Michelle: 2018 Artist Series Red Wine, Columbia Valley
    5637334326: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        },
        {
            rating: '94 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '5.1.22'
        }
    ],

    // Chateau Ste. Michelle: 2019 Artist Series Red Wine, Columbia Valley
    5637421342: [
        {
            rating: '94 Points',
            source: 'Wine & Spirits',
            date: '9.13.23'
        },
        {
            rating: '92+ Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '92+ Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        }
    ],

    // Chateau Ste. Michelle: 2019 Artist Series Red Wine, Columbia Valley
    5637470829: [
        {
            rating: '94 Points',
            source: 'Wine & Spirits',
            date: '9.13.23'
        },
        {
            rating: '92+ Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '92+ Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        }
    ],

    // Chateau Ste. Michelle: 2019 Artist Series Red Wine, Columbia Valley
    5637474593: [
        {
            rating: '94 Points',
            source: 'Wine & Spirits',
            date: '9.13.23'
        },
        {
            rating: '92+ Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '92+ Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        }
    ],

    // Chateau Ste. Michelle: 2016 Limited Release Boreal Syrah, Yakima Valley
    5637161247: [
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '2.1.21'
        }
    ],

        // Chateau Ste. Michelle: 2023 Limited Release Chenin Blanc
    5637683076: [
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        }
    ],

    // Chateau Ste. Michelle: 2018 Cabernet Sauvignon, Columbia Valley
    5637307326: [
        {
            rating: '91 Points',
            acclaim: '#1 Top 100 Best Buys 2021',
            source: 'Wine Enthusiast',
            date: '11.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2016 Canoe Ridge Estate Cabernet Sauvignon, Horse Heaven Hills
    5637190326: [
        {
            rating: '92 Points',
            acclaim: 'Year\'s Best US Cabernet/Blends',
            source: 'Wine & Spirits',
            date: '12.1.19'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '11.30.19'
        },
        {
            rating: '90+ Points',
            source: 'Vinous Media',
            date: '12.3.20'
        }
    ],

    // Chateau Ste. Michelle: 2017 Canoe Ridge Estate Cabernet Sauvignon, Horse Heaven Hills
    5637280340: [
        {
            rating: '91 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        },
        {
            rating: '90 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '5.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2018 Canoe Ridge Estate Cabernet Sauvignon, Horse Heaven Hills
    5637329086: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '2.7.22'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        }
    ],

    // Chateau Ste. Michelle: 2018 Canoe Ridge Estate Chardonnay, Horse Heaven Hills
    5637212838: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '7.12.21'
        },
        {
            rating: '90 Points',
            acclaim: 'Best Buy, Year\'s Best',
            source: 'Wine & Spirits',
            date: '10.15.21'
        }
    ],

    // Chateau Ste. Michelle: 2015 Canoe Ridge Estate Merlot, Horse Heaven Hills
    5637166371: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        }
    ],

    // Chateau Ste. Michelle: 2016 Canoe Ridge Estate Merlot, Horse Heaven Hills
    5637246578: [
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '90 Points',
            acclaim: 'Daily Wine Pick',
            source: 'Wine Spectator',
            date: '10.31.19'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '10.1.19'
        }
    ],

    // Chateau Ste. Michelle: 2017 Canoe Ridge Estate Merlot, Horse Heaven Hills
    5637169050: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '5.1.22'
        }
    ],

    // Chateau Ste. Michelle: 2019 Canoe Ridge Estate Merlot, Horse Heaven Hills
    5637648583: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '10.1.23'
        }
    ],

    // Chateau Ste. Michelle: 2016 Limited Release Canoe Ridge Estate Red Wine Blend, Horse Heaven Hills
    5637161219: [
        {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '11.30.21'
        }
    ],

    // Chateau Ste. Michelle: 2016 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637246577: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '6.1.20'
        },
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '12.1.20'
        }
    ],

    // Chateau Ste. Michelle: 2019 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637466332: [
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '9.1.23'
        }
    ],

    // Chateau Ste. Michelle: 2020 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637644082: [
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '12.1.23'
        }
    ],

    // Chateau Ste. Michelle: 2018 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637297583: [
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.13.22'
        },
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '12.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2018 Cold Creek Vineyard Chardonnay, Columbia Valley
    5637499342: [
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '3.1.23'
        }
    ],

    // Chateau Ste. Michelle: 2017 Cold Creek Vineyard Chardonnay, Columbia Valley
    5637246576: [
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.12.21'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2016 Cold Creek Vineyard Cabernet Sauvignon, Columbia Valley
    5637308838: [
        {
            rating: '92 Points',
            source: 'Wine & Spirits',
            date: '8.1.21'
        },
        {
            rating: '90 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '12.1.20'
        }
    ],


    // Chateau Ste. Michelle: 2011 Eroica Riesling, Columbia Valley
    5637166413: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '2.18.26'
        }
    ],

    // Chateau Ste. Michelle: 2017 Eroica Riesling, Columbia Valley
    5637160385: [
        {
            rating: '93 Points',
            acclaim: 'All Star, Year\'s Best US Rieslings, Best Buy',
            source: 'Wine & Spirits',
            date: '8.1.20'
        },
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '4.11.19'
        },
        {
            rating: '91 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '8.1.19'
        }
    ],

    // Chateau Ste. Michelle: 2018 Eroica Riesling, Columbia Valley
    5637176079: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '1.29.21'
        },
        {
            rating: '91 Points',
            acclaim: 'Editor\'s Choice, Top 100 Wines',
            source: 'Wine Enthusiast',
            date: '12.1.20'
        }
    ],

    // Chateau Ste. Michelle: 2018 Eroica Riesling, Columbia Valley
    5637286326: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '1.29.21'
        },
        {
            rating: '91 Points',
            acclaim: 'Editor\'s Choice, Top 100 Wines',
            source: 'Wine Enthusiast',
            date: '12.1.20'
        }
    ],

    // Chateau Ste. Michelle: 2018 Eroica Riesling, Columbia Valley
    5637282579: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '1.29.21'
        },
        {
            rating: '91 Points',
            acclaim: 'Editor\'s Choice, Top 100 Wines',
            source: 'Wine Enthusiast',
            date: '12.1.20'
        }
    ],

    // Chateau Ste. Michelle: 2019 Eroica Riesling, Columbia Valley
    5637282580: [
        {
            rating: '92 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        },
        {
            rating: '92 Points',
            source: 'Wine & Spirits',
            date: '8.1.21'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '7.12.21'
        }
    ],

    // Chateau Ste. Michelle: 2020 Eroica Riesling, Columbia Valley
    5637404826: [
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        },
        {
            rating: '92 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '5.1.22'
        },
        {
            rating: '92 Points',
            acclaim: 'Top 100 Best Buys',
            source: 'Wine & Spirits',
            date: '10.2.22'
        },
        {
            rating: '91 Points',
            acclaim: 'Smart Buy',
            source: 'Wine Spectator',
            date: '12.31.22'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        }
    ],

// Chateau Ste. Michelle: 2021 Eroica Riesling, Columbia Valley
    5637455076: [
        {
            rating: '91+ Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '91 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '11.1.22'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '91 Points',
            source: 'Vinous Media',
            date: '3.1.23'
        },
        {
            rating: '90 Points',
            acclaim: 'Value Pick of the Week',
            source: 'Wine Spectator',
            date: '11.2.22'
        }
    ],

    // Chateau Ste. Michelle: 2024 Eroica Riesling, Columbia Valley
    5637767077: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '2.18.26'
         },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            acclaim: 'Value Pick of the Week',
            date: '3.18.26'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '4.6.26'
        }
    ],

    // Chateau Ste. Michelle: 2022 Eroica Riesling, Columbia Valley
    5637563077: [
        {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        },
        {
            rating: '92 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '4.1.24'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        }
    ],

    // Chateau Ste. Michelle: 2015 Eroica Gold Riesling, Columbia Valley
    5637161111: [
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '92 Points',
            source: 'Wine & Spirits',
            date: '8.1.21'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '6.13.18'
        }
    ],

    // Chateau Ste. Michelle: 2016 Eroica Gold Riesling, Columbia Valley
    5637166340: [
                {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        },
        {
            rating: '92+ Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        },
        {
            rating: '92 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2019 Eroica Gold Riesling, Columbia Valley
    5637254083: [
        {
            rating: '94 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '7.6.21'
        }
    ],

    // Chateau Ste. Michelle: 2019 Eroica Ice Wine, Horse Heaven Hills
    5637536092: [
        {
            rating: '92 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '8.1.22'
        },
        {
            rating: '94 Points',
            source: 'Wine Spectator',
            date: '10.5.22'
        }
    ],

    // Chateau Ste. Michelle: 2016 Eroica Ice Wine, Horse Heaven Hills
    5637165740: [
        {
            rating: '95 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        },
        {
            rating: '94 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '4.1.19'
        },
        {
            rating: '94 Points',
            source: 'Wine Spectator',
            date: '6.13.18'
        }
    ],

    // Chateau Ste. Michelle: 2011 Eroica Single Berry Select, Columbia Valley
    5637166415: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '93 Points',
            source: 'Wine Enthusiast',
            date: '4.1.19'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '11.15.18'
        }
    ],

    // Chateau Ste. Michelle: 2012 Eroica Single Berry Select, Columbia Valley
    5637338168: [
        {
            rating: '100 Points',
            source: 'Wine & Spirits',
            date: '8.1.21'
        },
        {
            rating: '95 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '12.1.20'
        },
        {
            rating: '94+ Points',
            source: 'The Wine Advocate',
            date: '10.14.21'
       },
        {
            rating: '94 Points',
            source: 'Wine Spectator',
            date: '10.5.22'
        }
    ],

        // Chateau Ste. Michelle: 2013 Eroica Single Berry Select, Columbia Valley
    5637166414: [
        {
            rating: '95 Points',
            acclaim: 'Top 100 Wines',
            source: 'Wine & Spirits',
            date: '10.1.22'
        },
        {
            rating: '93 Points',
            source: 'Wine Enthusiast',
            date: '8.1.22'
        }
    ],

    // Chateau Ste. Michelle: 2016 Eroica Single Berry Select, Columbia Valley
    5637179828: [
        {
            rating: '99 Points',
            source: 'Owen Bargreen',
            date: '5.11.23'
        },
        {
            rating: '98 Points',
            source: 'Wine & Spirits',
            date: '7.5.23'
        },
        {
            rating: '95 Points',
            source: 'Wine Enthusiast',
            acclaim: 'Editor\'s Choice',
            date: '10.1.23'
        }
    ],

        // Chateau Ste. Michelle: 2017 Eroica Single Berry Select, Columbia Valley
    5637794835: [
        {
            rating: '100 Points',
            source: 'Owen Bargreen',
            date: '2.18.26'
        },
        {
            rating: '98 Points',
            source: 'Wine Enthusiast',
            acclaim: 'Cellar Selection',
            date: '4.6.26'
        }
    ],

    // Chateau Ste. Michelle: 2016 Eroica XLC Dry Riesling, Columbia Valley
    5637161248: [
        {
            rating: '94 Points',
            source: 'Jeb Dunnuck',
            date: '4.16.20'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '7.5.19'
        },
        {
            rating: '90 Points',
            source: 'Vinous Media',
            date: '12.3.19'
        }
    ],

    // Chateau Ste. Michelle: 2017 Eroica XLC Dry Riesling, Columbia Valley
    5637291581: [
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '5.6.21'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        },
        {
            rating: '91 Points',
            source: 'Wine & Spirits',
            date: '8.1.21'
        }
    ],

        // Chateau Ste. Michelle: 2018 Eroica XLC Dry Riesling, Columbia Valley
    5637284832: [
                {
            rating: '92 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '8.1.22'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        }
    ],

        // Chateau Ste. Michelle: 2019 Eroica XLC Dry Riesling, Columbia Valley
    5637552581: [
        {
            rating: '94+ Points',
            source: 'The Wine Advocate',
            date: '3.21.24'
        },
        {
            rating: '94 Points',
            source: 'Vinous Media',
            date: '3.1.23'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        },
        {
            rating: '91 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '11.1.22'
        }
    ],

        // Chateau Ste. Michelle: 2020 Eroica XLC Dry Riesling, Columbia Valley
    5637643328: [
        {
            rating: '94 Points',
            source: 'Owen Bargreen',
            date: '7.15.24'
        },
        {
            rating: '93 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '4.1.24'
        }
    ],

        // Chateau Ste. Michelle: 2021 Eroica XLC Dry Riesling, Columbia Valley
    5637734076: [
        {
            rating: '95 Points',
            source: 'Owen Bargreen',
            date: '2.18.26'
        },
        {
            rating: '94 Points',
            source: 'Vinous Media',
            date: '10.23.25'
        },
        {
            rating: '92 Points',
            source: 'Wine Spectator',
            date: '10.27.25'
        },
        {
            rating: '91 Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        }
    ],

    // Chateau Ste. Michelle: 2016 Ethos Reserve Cabernet Sauvignon, Columbia Valley
    5637237588: [
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '91 Points',
            acclaim: 'Year\'s Best US Cabernet/Blends',
            source: 'Wine & Spirits',
            date: '12.1.19'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '10.15.21'
        }
    ],

    // Chateau Ste. Michelle: 2017 Ethos Reserve Chardonnay, Columbia Valley
    5637161213: [
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        }
    ],

        // Chateau Ste. Michelle: 2020 Ethos Reserve Chardonnay, Columbia Valley
    5637423585: [
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            acclaim: 'Editor\'s Choice',
            date: '4.1.24'
        }
    ],

    // Chateau Ste. Michelle: 2017 Ethos Reserve Late Harvest Riesling, Columbia Valley
    5637176078: [
        {
            rating: '95 Points',
            acclaim: 'Year\'s Best US Rieslings',
            source: 'Wine & Spirits',
            date: '6.1.20'
        },
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '7.12.21'
        },
        {
            rating: '92+ Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        }
    ],

    // Chateau Ste. Michelle: 2014 Ethos Reserve Merlot, Columbia Valley
    5637161113: [
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2018 Ethos Reserve Cabernet Sauvignon, Columbia Valley
    5637297584: [
        {
            rating: '93 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        },
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '11.1.22'
        },
        {
            rating: '91 Points',
            source: 'Wine Spectator',
            date: '12.15.22'
        }
    ],

        // Chateau Ste. Michelle: 2019 Ethos Reserve Cabernet Sauvignon, Columbia Valley
    5637544327: [
                {
            rating: '93 Points',
            source: 'Owen Bargreen',
            date: '7.17.24'
        },
        {
            rating: '93 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '6.26.23'
        },
        {
            rating: '92 Points',
            source: 'The Wine Advocate.com',
            date: '3.21.24'
        },
        {
            rating: '92 Points',
            source: 'Vinous Media',
            date: '1.25.24'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '4.20.23'
        }
    ],

          // Chateau Ste. Michelle: 2021 Ethos Reserve Cabernet Sauvignon, Columbia Valley
    5637721334: [
        {
            rating: '92 Points',
            source: 'Wine Enthusiast',
            date: '12.1.24'
        },
        {
            rating: '92 Points',
            source: 'JamesSuckling.com',
            date: '3.5.24'
        }
    ],

    // Chateau Ste. Michelle: 2020 Indian Wells Chardonnay, Columbia Valley
    5637368080: [
                {
            rating: '90 Points',
            source: 'The Wine Advocate',
            date: '5.11.23'
        },
        {
            rating: '90 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        }
    ],

    // Chateau Ste. Michelle: 2022 Indian Wells Riesling, Columbia Valley
    5637542831: [
                {
            rating: '91 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '6.26.23'
        }
    ],

        // Chateau Ste. Michelle: 2022 Indian Wells Ros�, Columbia Valley
    5637563826: [
                {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '6.26.23'
        }
    ],

    // Chateau Ste. Michelle: 2015 Ethos Reserve Syrah, Columbia Valley
    5637161179: [
        {
            rating: '94 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '5.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2019 Horse Heaven Vineyard Sauvignon Blanc, Horse Heaven Hills
    5637282576: [
        {
            rating: '92 Points',
            acclaim: 'Editor\'s Choice',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        },
        {
            rating: '91 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        }
    ],

    // Chateau Ste. Michelle: 2020 Horse Heven Vineyard Sauvignon Blanc, Horse Heaven Hills
    5637373330: [
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine Enthusiast',
            date: '5.1.22'
        },
        {
            rating: '90 Points',
            source: 'JamesSuckling.com',
            date: '4.20.22'
        },
        {
            rating: '90 Points',
            source: 'Wine Spectator',
            date: '2.17.22'
        }
    ],

    // Chateau Ste. Michelle: 2021 Horse Heven Vineyard Sauvignon Blanc, Horse Heaven Hills
    5637470078: [
        {
            rating: '90 Points',
            acclaim: 'Best Buy',
            source: 'Wine & Spirits',
            date: '7.5.23'
        }
    ],

    // Chateau Ste. Michelle: 2016 IMPETUS Red Wine, Columbia Valley
    5637386083: [
        {
            rating: '94 Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2016 IMPETUS Red Wine, Columbia Valley
    5637166342: [
        {
            rating: '94 Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '6.29.21'
        },
        {
            rating: '91 Points',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        }
    ],

    // Chateau Ste. Michelle: 2017 IMPETUS Red Wine, Columbia Valley
    5637254082: [
        {
            rating: '95 Points',
            source: 'Jeb Dunnuck',
            date: '7.12.22'
        },
        {
            rating: '93 Points',
            source: 'Vinous Media',
            date: '3.22.22'
        },
        {
            rating: '93 Points',
            source: 'JamesSuckling.com',
            date: '4.6.22'
        },
        {
            rating: '92 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '5.1.22'
        }
    ],

    // Chateau Ste. Michelle: 2021 IMPETUS Red Wine, Columbia Valley
    5637672600: [
        {
            rating: '92 Points',
            source: 'Jeb Dunnuck',
            date: '7.10.25'
        },
        {
            rating: '90 Points',
            source: 'Wine Enthusiast',
            date: '12.1.24'
        }
    ],

        // Chateau Ste. Michelle: 2022 IMPETUS Red Wine, Columbia Valley
    5637734848: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        }
    ],

            // Chateau Ste. Michelle: 2022 IMPETUS Red Wine, Columbia Valley
    5637780576: [
        {
            rating: '92 Points',
            source: 'The Wine Advocate',
            date: '12.18.25'
        }
    ],

    // Chateau Ste. Michelle: 2017 Red Mountain Cabernet Sauvignon, Red Mountain
    5637308116: [
        {
            rating: '93+ Points',
            source: 'The Wine Advocate',
            date: '12.10.20'
        },
        {
            rating: '93 Points',
            source: 'Wine & Spirits',
            date: '12.1.21'
        },
        {
            rating: '91 Points',
            acclaim: 'Cellar Selection',
            source: 'Wine Enthusiast',
            date: '9.1.21'
        }
    ],
};